import { z } from "zod/v4";

export const GeoLocation = z.object({
  latitude: z
    .string()
    .max(10)
    .regex(/-?[0-9]{1,2}\.[0-9]{6}/),
  longitude: z
    .string()
    .max(11)
    .regex(/-?[0-9]{1,3}\.[0-9]{6}/),
});

export const DisplayText = z.object({
  language: z.string().length(2),
  text: z.string().max(512),
});

export const ImageCategory = z.enum([
  "CHARGER",
  "ENTRANCE",
  "LOCATION",
  "NETWORK",
  "OPERATOR",
  "OTHER",
  "OWNER",
]);

export const Image = z.object({
  url: z.url(),
  thumbnail: z.url().nullish(),
  category: ImageCategory,
  type: z.string().max(4),
  width: z.number().int().max(99999).nullish(),
  height: z.number().int().max(99999).nullish(),
});

export const BusinessDetails = z.object({
  name: z.string().max(100),
  website: z.url().nullish(),
  logo: Image.nullish(),
});
